/*
create-prize-list.component.ts
Golfhubber
Created by Chetan Baghel on 23/06/2021.
Copyright © 2021 Golfhubber Ltd. All rights reserved.
*/
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AngularFireDatabase } from 'angularfire2/database';

@Component({
  selector: 'app-create-prize-list',
  templateUrl: './create-prize-list.component.html',
  styleUrls: ['./create-prize-list.component.scss']
})
export class CreatePrizeListComponent implements OnInit {
  
  noOfPositions: number = 0;
  tournamentId: any;
  tournament: any;
  prizeList = [];
  positionInput: any;
  prizeInput: any;

  constructor(
    private route: ActivatedRoute,
    private fireDatabase: AngularFireDatabase,
  ) { }

  ngOnInit() {
    this.tournamentId = this.route.snapshot.paramMap.get('tournamentId');
    this.noOfPositions = parseInt(this.route.snapshot.paramMap.get('noOfPositions'));
    this.positionInput = this.noOfPositions + 1;
    if (this.noOfPositions != -1)// create
    {
       for (let i = 0; i < this.noOfPositions; i++){
          this.add(i, 0);
        }
    }
    else //edit
    {
      this.fireDatabase.database.ref(`/multi-round/${this.tournamentId}`).on("value", result => {
        this.tournament = result.val();
        Object.assign(this.tournament, { $key: this.tournamentId });
        for (let i = 0; i < this.tournament.prizes.length; i++){
          this.add(i, this.tournament.prizes[i].prize);
        }
      });
      
    }
  }

  validateList()
  {
    let validate = false;    
    this.prizeList.forEach(element => {
      if (element.prize === "" || element.position === "")
      {
        validate = true;
      }
    })    
    return validate
  }

  add(position, prize)
  {
    let item = { position: position + 1, prize: prize};
    this.prizeList.push(item);
    this.positionInput = this.prizeList.length + 1;
    this.prizeInput = 0;
  }

  remove(index)
  {
    this.prizeList.splice(index, 1);
    for (let j = index; j < this.prizeList.length; j++)
    {
      this.prizeList[j].position = j + 1;
    }
  }

  checkOdd(value) {
    return (value % 2 == 0)
  }

  validateForm()
  {

  }

  submit() {
    if (this.positionInput && this.prizeInput)
    {
      this.prizeList.push({ position: this.positionInput, prize: parseFloat(this.prizeInput)})
    }
    this.fireDatabase.database.ref(`/multi-round/${this.tournamentId}`).child(`prizes`).set(this.prizeList);
    window.history.back();
  }
}
